import { createFileRoute } from '@tanstack/react-router'
import SupportContent from '~/features/contact/components/SupportContent'

export const Route = createFileRoute('/support')({
  component: SupportContent,
})
